interface Input {
  readonly code: string;
  readonly codingConfig: object;
}

export const getServiceCode = (service: Readonly<Input>) =>
  service.code ||
  ('code' in service.codingConfig &&
  typeof service.codingConfig.code === 'string'
    ? service.codingConfig.code
    : 'Code inconnu');
